import { useCallback, useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { nextNavigate, handleNavigateAtSource } from 'src/utils/navigation-utils';
import { useRouter } from 'src/hooks/use-router';

export const useListSearch = () => {
  const location = useLocation();

  const { page, query, rows, holder } = useMemo(
    () => handleNavigateAtSource(location),
    [location],
  );
  const router = useRouter();
  const [state, setState] = useState({
    filters: {
      query: query,
    },
    page: page,
    rowsPerPage: rows,
    holder: holder,
  });

  // To reset the state, use setState like this:
  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        query: query,
      },
      page: page,
      rowsPerPage: rows,
    }));
  }, [page, query, rows]);

  const handleFiltersChange = useCallback((filters) => {
    setState((prevState) => ({
      ...prevState,
      filters,
    }));
  }, []);

  const handlePageChange = useCallback((event, page) => {
    setState((prevState) => ({
      ...prevState,
      page,
    }));
  }, []);

  const handleRowsPerPageChange = useCallback((event) => {
    const limitPerPage = parseInt(event.target.value, 10);
    localStorage.setItem('cache_rowsPerPage', limitPerPage);
    setState((prevState) => ({
      ...prevState,
      rowsPerPage: limitPerPage,
      rows: limitPerPage,
      page: 0,
    }));
  }, []);

  const handleNavigateChange = (nextLink, nextParam, prevLink) => {
    nextNavigate(router, state, nextLink, prevLink, nextParam);
  };

  return {
    state,
    handleFiltersChange,
    handlePageChange,
    handleRowsPerPageChange,
    handleNavigateChange,
  };
};
